/**
 * SocialButton Orcid component script file
 *
 * @package    Containers
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { OrcidLogin } from 'Containers/OrcidLogin';
import Button from 'Common/CustomButtons/Button';

import { withStyles } from '@material-ui/core/styles';

import styles from './styles.js';

@withStyles(styles)
export default class SocialButtonOrcid extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        config: PropTypes.shape({
            clientId: PropTypes.string.isRequired,
        }).isRequired,
        onSuccess: PropTypes.func.isRequired,
        onFailure: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired,
        title: PropTypes.string.isRequired,
        redirectUri: PropTypes.string,
    };

    render() {
        const {
            config: { clientId },
            classes,
            onSuccess,
            onFailure,
            title,
            redirectUri
        } = this.props;

        return (
            <OrcidLogin
                tag="a"
                className="btn-floating linkLogin btn-sm blue-gradient"
                clientId={clientId}
                onSuccess={onSuccess}
                onFailure={onFailure}
                redirectUri={redirectUri}
            >
                <Button color="simple" justIcon customClass={classes.customButtonClass}>
                    <i className="iconLogin" />{title}
                </Button>
            </OrcidLogin>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/SocialButtons/SocialButtonOrcid.jsx